var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-text-field",
    _vm._g(
      _vm._b(
        {
          attrs: {
            id: _vm.inputId,
            "aria-required": _vm.required,
            "aria-invalid": _vm.hasError,
            "aria-describedby": _vm.describedBy,
            error: _vm.hasError,
            "error-messages": _vm.errorMessages,
          },
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function (_, slot) {
                return {
                  key: slot,
                  fn: function (scope) {
                    return [_vm._t(slot, null, null, scope)]
                  },
                }
              }),
              _vm.hasError
                ? {
                    key: "message",
                    fn: function ({ message }) {
                      return [
                        _c(
                          "span",
                          { attrs: { id: _vm.errorId, role: "alert" } },
                          [_vm._v(_vm._s(message))]
                        ),
                      ]
                    },
                  }
                : null,
            ],
            null,
            true
          ),
        },
        "v-text-field",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }